
































































































import { Component, Emit, Mixins, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import AppHeader from "@/components/main/AppHeader.vue";
import AppMenu from "@/components/main/AppMenu.vue";
import VisitingBar from "@/components/main/VisitingBar.vue";
import BulletinBoardAdminDialog from "@/components/main/BulletinBoardAdminDialog.vue";
import QuestionDialog from "@/components/main/QuestionDialog.vue";
import MaintenanceInfoDialog from "@/components/main/MaintenanceInfoDialog.vue";
import { Mutation, namespace, State, Getter } from "vuex-class";
import { TokenObj, SideMenu } from "@/components/app/types";
import * as master from "@/store/modules/master/types";
import * as root from "@/store/types";
import { BulletinBoardAdmin } from "#/model/bulletinboard";
import {
  MaintenanceInfo,
  DefaultMaintenanceInfo
} from "#/model/admin/maintenanceInfo";
import { Question, DEFAULT_QUESTION } from "#/model/admin/question";
import VisitTmpDataMixin from "@/mixins/visitTmpDataMixin";
import * as constant from "#/const";
import UtilMixin from "@/mixins/utilMixin";
import { OFFICE_STAFF } from "#/const";
import { Route } from "vue-router";
import FirestoreMixin, { Collections } from "@/mixins/firestoreMixin";
import { ButtonItems } from "@/components/home/types";
import { VisitModel } from "@/components/main/types";
import * as lib from "#/store/types";
import { FONT_SIZE } from "@/types";

const Master = namespace(master.name);

@Component({
  components: {
    AppHeader,
    AppMenu,
    VisitingBar,
    BulletinBoardAdminDialog,
    MaintenanceInfoDialog,
    QuestionDialog
  }
})
export default class Main extends Mixins(
  AxiosMixin,
  VisitTmpDataMixin,
  UtilMixin,
  FirestoreMixin
) {
  /** 一般職員権限 */
  private STAFF_COMMON = OFFICE_STAFF.AUTH.COMMON;

  @Master.Mutation(master.SET_MASTER) setMaster!: Function;

  @Mutation(root.SET_IS_REGISTERD_AUTH_NAVIGATION)
  setIsRegisterdAuthNavigation!: Function;

  @State is_registerd_auth_navigation!: boolean;

  @Mutation(root.SET_IS_VISIT_NAVIGATION) setIsVisitNavigation!: Function;

  @State is_visit_navigation!: boolean;

  @State("chat") chatState!: lib.ChatState;

  @Mutation(lib.SET_AGREEMENTS, { namespace: "chat" })
  setAgreements!: Function;

  @Getter("HasChatEnabledAgreement", { namespace: "chat" })
  hasChatEnabledAgreement!: boolean;

  private isShownChatView = false;
  private unreadChatCount = 0;

  /** マスタデータ読み取り完了フラグ */
  private isLoadedMaster = false;

  /** 管理者掲示板(お知らせ) */
  private bulletin_board_admins: BulletinBoardAdmin[] = [];

  /** 掲示板ダイアログ表示フラグ */
  private isBulletinBoardDialogs: boolean[] = [];

  /** メンテナンス通知（お知らせ） */
  private maintenance_infos: MaintenanceInfo[] = [];

  /** メンテナンス情報 */
  private maintenance_info: MaintenanceInfo = DefaultMaintenanceInfo();

  /** メンテナンス通知ダイアログ表示フラグ */
  private isMaintenanceInfoDialogs: boolean[] = [];

  /** アンケート */
  private questions: Question[] = [];

  /** 表示対象アンケート */
  private showingQuestion: Question = { ...DEFAULT_QUESTION };

  /** サイドメニューの開閉状態 */
  private sideMenu: SideMenu = {
    isOpen: this.$vuetify.breakpoint.lgAndUp,
    isNarrow: false
  };

  /** デフォルトのフォントサイズ 0:デフォルト 1:大きく 2:もっと大きく */
  private selectFontSize = 0;

  /** 訪問データモデル */
  private get VisitModel(): VisitModel {
    return this.visitTmpDataState.data as VisitModel;
  }

  /** 訪問中かどうか */
  private get IsVisit() {
    if (this.VisitModel && this.VisitModel.mode) {
      return true;
    }
    return false;
  }

  private get VisitMode() {
    if (this.IsVisit) {
      return this.VisitModel.mode;
    }
    return 0;
  }

  /** 共通エリアを表示するかどうか */
  private get IsCommonArea() {
    return this.isLoadedMaster && !this.$route.meta?.isNoCommonArea;
  }

  /** アンケートダイアログ */
  @Ref("question_dialog") private readonly questionDialog!: QuestionDialog;

  created() {
    // 所属法人の取得
    this.postJsonBackground(
      window.chat_backend_url + "/api/chat/corps/get",
      {},
      res => {
        this.setAgreements(res.data.corps);
      }
    );
  }

  async mounted() {
    //起動時にログイン情報をチェック && マスタ取得
    this.postJsonCheck(
      window.base_url + "/api/master/get",
      {},
      async res => {
        // マスターデータ設定
        this.setMaster(res.data);

        // アンケート
        this.questions = res.data.questions ? res.data.questions : [];

        // お知らせ設定
        this.initDialog(
          res.data.bulletin_board_admins,
          res.data.maintenance_infos
        );

        // フォントサイズ設定
        await this.initFontsize();

        // メンテナンス設定
        this.maintenance_info = res.data.maintenance_info;
        if (this.maintenance_info && this.maintenance_info.id != 0) {
          this.toMainte();
        }

        // 訪問状態制御
        const isStopVisit = await this.initVisit();

        //権限チェックの制御（画面起動時）
        const isStopAuth = this.initAuth();

        // マスターデータ設定
        if (isStopVisit && isStopAuth) {
          this.isLoadedMaster = true;
        }
      },
      () => {
        window.history.back();
      }
    );
  }

  // 訪問中もアクセス可能なURL判定
  private agreeVisitUrl(route: Route) {
    if (!route.name) {
      return false;
    }
    // 訪問中もアクセスを許可する画面
    return route.path.indexOf(`/visit/${this.VisitModel.patient_id}`) === 0;
  }

  /** サイドメニュー表示非表示の切り替え */
  private toggleSideOpen() {
    this.sideMenu.isOpen = !this.sideMenu.isOpen;
  }

  /** サイドメニューの幅変更 */
  private toggleSideNarrow() {
    this.sideMenu.isNarrow = !this.sideMenu.isNarrow;
  }

  /** アンケートダイアログを表示 */
  private reopenQuestionDialog() {
    // アンケート情報が存在しない場合は何もしない
    if (this.questions.length == 0) {
      return;
    }

    // 全アンケート情報から1つ取り出してダイアログを表示
    this.showingQuestion = this.questions.slice()[0];
    this.questions.splice(0, 1);

    // 時間を置いてから再表示
    setTimeout(() => {
      this.questionDialog.openDialog();
    }, 300);
  }

  /** 訪問状態の強制終了 */
  private async deleteVisitStatus() {
    await this.deleteVisitTmpData();
    this.$router.replace("/");
  }

  /** 文字サイズ変更 */
  private setFontSize() {
    const htmlElem = document.getElementsByTagName("html");
    switch (this.selectFontSize) {
      case FONT_SIZE.DEFAULT:
        htmlElem[0].style.fontSize = "100%";
        break;
      case FONT_SIZE.SIZE_L:
        htmlElem[0].style.fontSize = "115%";
        break;
      case FONT_SIZE.SIZE_LL:
        htmlElem[0].style.fontSize = "130%";
        break;
    }
  }

  private unreadChatCountChanged(count: number) {
    this.unreadChatCount = count;
  }

  /** フォントサイズ初期化 */
  private async initFontsize() {
    if (!this.loginUser.id) {
      return;
    }

    // データ取得
    const { data, error } = await this.getFirestore(
      Collections.HomeItemList,
      String(this.loginUser.id)
    );
    if (error) {
      // firestore取得失敗
      this.$openAlert(
        "正しい画面情報が取得できませんでした。画面を更新して再度お試しください。"
      );
      return;
    }

    const documentButtonItem = data as ButtonItems;
    if (documentButtonItem) {
      this.selectFontSize = documentButtonItem.selectFontSize;
    }

    // 文字サイズ変更
    this.setFontSize();
    window.font_size = this.selectFontSize;
  }

  /** ダイアログ初期化 */
  private initDialog(
    bulletin_board_admins: BulletinBoardAdmin[],
    maintenance_infos: MaintenanceInfo[]
  ) {
    // ホーム画面の時だけダイアログを表示
    if (location.pathname != "/") {
      return;
    }

    // お知らせ
    this.bulletin_board_admins = bulletin_board_admins;
    // メンテナンス情報のお知らせ
    this.maintenance_infos = maintenance_infos;

    for (let i = 0; i < this.bulletin_board_admins.length; i++) {
      this.isBulletinBoardDialogs.push(true);
    }
    for (let i = 0; i < this.maintenance_infos.length; i++) {
      this.isMaintenanceInfoDialogs.push(true);
    }
    this.reopenQuestionDialog();
  }

  /** 訪問制御初期化 */
  private async initVisit(): Promise<boolean> {
    //訪問中の制御（画面起動時）
    const isStop = await this.initVisitUrl();

    //訪問中の制御（ルーティング） ※一度だけ設定
    if (!this.is_visit_navigation) {
      this.setIsVisitNavigation(true);
      this.$router.beforeEach(this.visitBeforeEach);
    }

    return isStop;
  }

  /** 起動時のURL制御 */
  private initVisitUrl(): Promise<boolean> {
    return this.visitMoveTemplate(
      this.$route,
      () => {
        location.href = `/visit/${this.VisitModel.patient_id}/move`;
      },
      () => {
        location.href = `/visit/${this.VisitModel.patient_id}/stay`;
      },
      () => {
        location.href = "/";
      },
      () => {
        //何もしない
      }
    );
  }

  /** 遷移時のFunction */
  private visitBeforeEach(to: Route, from: Route, next: Function) {
    this.visitMoveTemplate(
      to,
      () => {
        next({
          name: "VisitMove",
          params: { id: String(this.VisitModel.patient_id) }
        });
      },
      () => {
        next({
          name: "VisitStay",
          params: { id: String(this.VisitModel.patient_id) }
        });
      },
      () => {
        next({
          name: "Home"
        });
      },
      () => {
        next();
      }
    );
  }

  private async visitMoveTemplate(
    to: Route,
    toMove: () => void,
    toStay: () => void,
    toHome: () => void,
    toDefault: () => void
  ): Promise<boolean> {
    // 一時訪問データの取得
    if (!this.loginUser.id) {
      toDefault();
      return true;
    }
    await this.getVisitTmpData(String(this.loginUser.id));

    // 訪問中でない場合は何もしない
    if (!this.VisitModel) {
      toDefault();
      return true;
    }

    // 許可されているURLの場合は何もしない
    if (this.agreeVisitUrl(to)) {
      toDefault();
      return true;
    }

    switch (this.VisitMode) {
      case constant.VISIT_RECORD.MODE_MOVE:
        if (
          to.path.match(/\/visit\/\d+\/move/) &&
          to.path !== `/visit/${this.VisitModel.patient_id}/move`
        ) {
          // 別の利用者への移動の場合、一時訪問データは削除する
          await this.deleteVisitTmpData();
          toDefault();
          return true;
        } else {
          toMove();
          return false;
        }
      case constant.VISIT_RECORD.MODE_STAY:
        toStay();
        return false;
      default:
        //おかしなMODEで訪問中であれば、一時訪問データは消してホーム画面に戻す
        await this.deleteVisitTmpData();
        toHome();
        return false;
    }
  }

  private initAuth(): boolean {
    //権限チェックの制御（画面起動時）
    let isStop = true;
    if (
      this.loginUserAuthId <= this.STAFF_COMMON &&
      this.$route.meta?.isNotNormal == 1
    ) {
      this.$router.replace("/");
      isStop = false; //他の画面に遷移する
    }

    //権限チェックの制御（ルーティング） ※一度だけ設定
    if (!this.is_registerd_auth_navigation) {
      this.setIsRegisterdAuthNavigation(true);
      this.$router.beforeEach((to, from, next) => {
        if (this.loginUserAuthId > this.STAFF_COMMON) {
          next();
          return;
        }
        //ページごとの判定
        if (to.meta?.isNotNormal == 1) {
          next(false);
          return;
        }
        next();
      });
    }
    return isStop;
  }

  @Emit()
  private toMainte() {
    return this.maintenance_info;
  }

  @Emit()
  private changeStaff(selectOffice: TokenObj) {
    return selectOffice;
  }

  @Emit()
  private toLogout() {
    return;
  }
}
